import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";

import { IonicModule } from "@ionic/angular";

import { BlogDetailPageRoutingModule } from "./blog-detail-routing.module";

import { BlogDetailPage } from "./blog-detail.page";
import { PagesModule } from "../pages.module";

@NgModule({
  imports: [
    IonicModule,
    CommonModule,
    FormsModule,
    PagesModule,
    BlogDetailPageRoutingModule,
  ],
  declarations: [BlogDetailPage],
})
export class BlogDetailPageModule {}
